import { Injectable } from '@angular/core';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { FunctionsService, GeneratePdfService, HttpService, LocalStorageService, MessageService, params, PurchaseOrderItemReport, TemplatePdfOt, TemplatePdfPurchaseOrder, TemplatePdfFo } from 'brainloper-ui';
import { Image2Base64ConverterService } from './image2-base64-converter.service';
import { Company } from 'src/app/models/administration/company';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { FuelOrder } from 'src/app/models/fuel/fuel-order';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';

@Injectable({
  providedIn: 'root'
})
export class GeneratePdfFosilService {
  [x: string]: any;

  private urlPostOT: string = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`
  private urlGetTablaUsuariosOrdenes: string = `${EndpointDictionary.UserOrder.USER_ORDER_TABLE}`
  private urlPostFO: string = `${EndpointDictionary.HistoricalFuel.CRUD_HISTORICAL_FUEL_DATA}`;

  public companyId: number | null = null;

  constructor(
    private http: HttpService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private base64: Image2Base64ConverterService,
    private generatepdf: GeneratePdfService,
    private storage: LocalStorageService
  ) {
    this.companyId = this.storage.get('companyId');
  }

  async printTemplateOt(id: number, autogenerate?: boolean) {

    this.message.openLoading("Cargando...", "Cargando información de la orden de trabajo")
    let dataCompany: Company | null = this.storage.get<Company>('company')
    if (!dataCompany || dataCompany.id == null) {
      this.message.closeLoading()
      this.message.Error('Error', 'No se encontró la información de la empresa.')
      return
    }
    let urlLogo: string = `${EndpointDictionary.Base._BASE_URL_V2}${dataCompany.logo}/0`
    let logoBase64: string = await this.base64.convert(urlLogo) as string

    let getDataOT: ResponseGetData = await this.getDataOT(id, dataCompany.id)
    let request: TemplatePdfOt = {
      address: dataCompany.address,
      addressProvider: getDataOT.addressProvider,
      approved_by: getDataOT.bodyOT.authorizesName,
      area: getDataOT.bodyOT.areaName,
      name: dataCompany.name,
      code: getDataOT.bodyOT.code,
      consecutive: getDataOT.bodyOT.consecutive,
      date: this.functionEter.dateIso(getDataOT.bodyOT.executionDate),
      description: getDataOT.bodyOT.resources ? `${getDataOT.bodyOT.description}\n\nRecursos:\n\n${getDataOT.bodyOT.resources}` : getDataOT.bodyOT.description,
      image: logoBase64,
      mail: getDataOT.bodyOT.email != "" && getDataOT.bodyOT.email != null ? getDataOT.bodyOT.email : dataCompany.email,
      nameProvider: getDataOT.bodyProvider,
      nit: dataCompany.nit,
      odometer: getDataOT.bodyOT.currentOdometer,
      invoiceReference: getDataOT.bodyOT.invoiceReference,
      responsible: getDataOT.bodyOT.responsible,
      telephone: dataCompany.phone,
    }
    let a: boolean = false
    if (autogenerate) {
      a = autogenerate
    }
    this.message.closeLoading()
    let res = await this.generatepdf.getPdfOt(request, a)
    return res

  }

  private async getDataOT(id: number, id_company: number) {
    try {
      // let params: params[] = [{ id: 'page', value: 0 }, { id: 'per_page', value: 12 }, { id: 'filter', value: '' }, { id: 'orderId', value: id }]
      let res: Array<WorkOrder> = await this.http.getDataBody(`${this.urlPostOT}/${id}`, [{ id: 'withUserWo', value: 'true' }])
      // let resTable: BaseResponseData<Array<UserWO>> = await this.http.getDataPromise(`${this.urlGetTablaUsuariosOrdenes}`, params)
      let addressProvider: string | undefined = ""
      let usuariosOrden: string = ""

      if (res) {
        if (res[0] && res[0].userWO && res[0].userWO.length > 0) {
          let string = ''
          let response = ''
          let i = 0
          if (res[0].userWO[0].responsibleType == "tercero") {
            addressProvider = res[0].userWO[0].providerAddress
          } else {
            addressProvider = ""
          }
          for (let element of res[0].userWO) {
            if (i == 0) {
              response = `${element.name}`
            } else {
              response = `${response}, ${element.name}`
            }
            string = response
            i = i + 1
          }
          usuariosOrden = string
          return {
            res: true,
            bodyOT: res[0],
            bodyProvider: usuariosOrden,
            addressProvider
          }
        } else {
          usuariosOrden = 'N/A',
            addressProvider = 'N/A'
          return {
            res: true,
            bodyOT: res[0],
            bodyProvider: usuariosOrden,
            addressProvider
          }
        }
      } else {
        return {
          res: false
        }
      }
    } catch (error) {
      this.message.Error('Error', error as string)
      return {
        res: false
      }
    }
  }

  private async getDataFO(id: number): Promise<ResponseGetData> {
    try {
      let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${id}`)

      if (res) {
        return {
          res: true,
          bodyFO: res[0],
        }

      } else {
        this.message.Error('Error', res['message'])
        return {
          res: false
        }
      }
    } catch (error) {
      this.message.Error('Error', error as string)
      return {
        res: false
      }
    }
  }

  async printTemplateFO(id: number, autogenerate?: boolean) {

    this.message.openLoading("Cargando...", "Cargando información de la orden de combustible")
    let dataCompany: Company | null = await this.storage.get<Company>('company')
    if (!dataCompany || dataCompany.id == null) {
      this.message.closeLoading()
      this.message.Error('Error', 'No se encontró la información de la empresa.')
      return
    }
    let urlLogo: string = `${EndpointDictionary.Base._BASE_URL_V2}${dataCompany.logo}/0`
    let logoBase64: string = await this.base64.convert(urlLogo) as string

    let getDataFO: ResponseGetData = await this.getDataFO(id)
    if(getDataFO.res == false || getDataFO.bodyFO == null){
      this.message.Error('Error', 'No se pudo obtener la información de la orden de combustible.')
      this.message.closeLoading()
      return
    }
    let dc = 'Combustible: ' + getDataFO.bodyFO.fuelType
    let d = (getDataFO.bodyFO.totalPrice ?? 0) > 0 ? dc + `, Valor: ${getDataFO.bodyFO.totalPrice}` : dc
    let de = (getDataFO.bodyFO.gallons ?? 0) > 0 ? d + `,  Galones: ${getDataFO.bodyFO.gallons}` : d


    let request: TemplatePdfFo = {
      name: dataCompany.name,
      nit: dataCompany.nit,
      address: dataCompany.address,
      telephone: dataCompany.phone,
      mail: getDataFO.bodyFO.email != "" && getDataFO.bodyFO.email != null ? getDataFO.bodyFO.email : dataCompany.email,
      image: logoBase64,
      code: getDataFO.bodyFO.code,
      date: this.functionEter.dateIso(getDataFO.bodyFO.date),
      responsible: getDataFO.bodyFO.requestsName,
      approved_by: getDataFO.bodyFO.authorizeName,
      detalle: de,
      description: getDataFO.bodyFO.description,
      consecutive: getDataFO.bodyFO.consecutive?.toString(),
      namePlace: getDataFO.bodyFO.place,
      addressPlace: getDataFO.bodyFO.addressProvider ? getDataFO.bodyFO.addressProvider : "",
      odometer: getDataFO.bodyFO.currentOdometer ? getDataFO.bodyFO.currentOdometer.toString() : "",
      area: getDataFO.bodyFO.equipmentArea
    }
    let a: boolean = false
    if (autogenerate) {
      a = autogenerate
    }
    this.message.closeLoading()
    let res = await this.generatepdf.getPdfFo(request, a)
    return res

  }

  async generatePurchaseOrderPDF(puchageOrderId: number) {
    this.message.openLoading('Cargando', 'Generando PDF de orden de compra')
    let dataCompany: Company | null = await this.storage.get<Company>('company')
    if (!dataCompany || dataCompany.id == null) {
      this.message.closeLoading()
      this.message.Error('Error', 'No se encontró la información de la empresa.')
      return
    }

    let response = await this.http.getDataBody<Array<HistoryInventory>>(
      `${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}/${puchageOrderId}`
    );
    if (!response || response[0] == null) {
      this.message.closeLoading()
      this.message.Error('Error', 'No se encontró la información de la orden de compra.')
      return
    }

    let puchageOrder = response[0];
    var body: TemplatePdfPurchaseOrder = {
      consecutive: puchageOrder.consecutive?.toString(),
      created: puchageOrder.created,
      image: `${EndpointDictionary.Base._BASE_URL_V2}${dataCompany.logo}/0`,
      name: dataCompany.name,
      nit: dataCompany.nit,
      address: dataCompany.address,
      telephone: dataCompany.phone,
      mail: dataCompany.email,
      providerName: puchageOrder.providerName ?? '',
      requestsName: puchageOrder.requestsName ?? '',
      authorizeName: puchageOrder.authorizeName ?? '',
      warehouse: puchageOrder.warehouse ?? '',
      comment: puchageOrder.comment ?? '',
      totalCost: puchageOrder.totalCost,
      items: puchageOrder.items?.map(item => {
        return {
          code: item.code,
          itemName: item.itemName,
          unitMeasurement: item.unitMeasurement,
          amount: item.amount,
          costItem: item.costItem,
          totalCostItems: item.totalCostItems
        } as PurchaseOrderItemReport
      }) ?? []
    }
    await this.generatepdf.generatePurchaseOrderPDF(body)
    this.message.closeLoading()
  }

}
interface ResponseGetData {
  res: boolean,
  bodyOT?: any,
  bodyFO?: FuelOrder,
  bodyProvider?: string,
  addressProvider?: string
}
